/** Search line loader themes (run 24, Levan 11.10.2026): what travels the line and where it arrives. */
export type SearchLoaderTheme =
  'hotels' | 'tours' | 'excursions' | 'cruises' | 'avia' | 'transfers' | 'insurance' | 'reservations' | 'generic';

export type SearchLoaderIcon =
  | 'car'
  | 'plane'
  | 'ship'
  | 'suitcase'
  | 'magnifier'
  | 'hotel'
  | 'resort'
  | 'park'
  | 'island'
  | 'landing'
  | 'pin'
  | 'shield'
  | 'document';

export type SearchLoaderPath = 'road' | 'air' | 'sea';

export interface SearchLoaderThemeSpec {
  traveller: SearchLoaderIcon;
  destination: SearchLoaderIcon;
  path: SearchLoaderPath;
}

export const SEARCH_LOADER_THEMES: Record<SearchLoaderTheme, SearchLoaderThemeSpec> = {
  hotels: { traveller: 'car', destination: 'hotel', path: 'road' },
  tours: { traveller: 'plane', destination: 'resort', path: 'air' },
  excursions: { traveller: 'car', destination: 'park', path: 'road' },
  cruises: { traveller: 'ship', destination: 'island', path: 'sea' },
  avia: { traveller: 'plane', destination: 'landing', path: 'air' },
  transfers: { traveller: 'car', destination: 'pin', path: 'road' },
  insurance: { traveller: 'suitcase', destination: 'shield', path: 'air' },
  reservations: { traveller: 'magnifier', destination: 'document', path: 'air' },
  generic: { traveller: 'magnifier', destination: 'pin', path: 'air' }
};

/** The theme of the page a URL belongs to - for the fallback line, which has no page to name it. */
export const searchLoaderThemeOf = (url: string | null | undefined): SearchLoaderTheme => {
  const first = (url ?? '').split(/[?#]/)[0].split('/').find(Boolean)?.toLowerCase() ?? '';
  if (first.startsWith('hotel')) return 'hotels';
  if (first.startsWith('tour')) return 'tours';
  if (first.startsWith('excursion')) return 'excursions';
  if (first.startsWith('cruise')) return 'cruises';
  if (first.startsWith('avia') || first.startsWith('flight')) return 'avia';
  if (first.startsWith('transfer')) return 'transfers';
  if (first.startsWith('insurance')) return 'insurance';
  if (first.startsWith('reservation') || first.startsWith('cabinet')) return 'reservations';
  return 'generic';
};
